import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DrawingService} from '../../services/drawing.service';
import {EntityImage} from '../../classes/entityimage';
import {Title} from '@angular/platform-browser';
import {CodaltComponent} from '../codalt/codalt.component';
import {ActivatedRoute, Router} from '@angular/router';
import {FormControl} from '@angular/forms';
import {debounceTime} from 'rxjs/operators';

@Component({
    selector: 'app-entities',
    templateUrl: './entities.component.html',
    styleUrl: './entities.component.scss'
})
export class EntitiesComponent extends CodaltComponent implements OnInit {

    items: {
        entity: EntityImage,
        blob: string
    }[];
    skip = 0;
    fcSearch = new FormControl<string>(null);

    @ViewChild('container') container: ElementRef<HTMLDivElement>;

    constructor(private http: HttpClient,
                private drawingService: DrawingService,
                private title: Title,
                private activatedRoute: ActivatedRoute,
                private router: Router) {
        super();
    }

    ngOnInit() {
        this.title.setTitle('Entity images');
        const params = this.activatedRoute.snapshot.params as { skip: number };
        this.skip = isNaN(+params.skip) ? 0 : +params.skip;
        this.load();
        this.subscriptions.add(this.fcSearch.valueChanges.pipe(debounceTime(300)).subscribe(() => {
            this.load();
        }));
    }

    next() {
        this.skip++;
        this.router.navigate(['entities', this.skip], {replaceUrl: true});
        this.load();
    }

    private load() {
        this.subscriptions.add(this.drawingService.getEntities(this.skip, this.fcSearch.value).subscribe(entities => {
            this.items = [];
            if (entities.data.length === 0 && this.skip > 0) {
                this.skip = 0;
                this.load();
            }
            entities.data.forEach(entity => {
                entity.entities = [...entity.plain_entities, ...entity.projected_entities, ...entity.gnd_entities];
                let blob = new Blob([entity.svg], {type: 'image/svg+xml'});
                this.items.push({
                    entity,
                    blob: URL.createObjectURL(blob)
                });
            })
        }));
    }

}
